import { render } from "./AvatarLooksModal.vue?vue&type=template&id=5d94b440"
import script from "./AvatarLooksModal.vue?vue&type=script&lang=js"
export * from "./AvatarLooksModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__